/*
 * 苏州海管家物流科技有限公司（https://www.hgj.com/）.
 * 苏公网安备32059002003385号 © 2015-2023 Hgj.com All Rights Reserved. | 苏ICP备15030950号.
 * @Date: 2023.09.05.
 * @Author
 * @Description 恪保 - 路由表 总入口.
 **/
import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router'
import { useToolStore } from '@/store/tool'
import useTabs from '@/hooks/useTabs'
import useMenu from '@/hooks/useMenu'
import { normalizeBasePath } from '@/utils/base'
import { isGlobal } from '@/utils/constant'
const { activeTabName } = useTabs()
const { activeMenuName } = useMenu()
/*
RouteRecordRaw = [
	path: string,        // 记录的路径,应该以 / 开头，除非该记录是另一条记录的子记录。可以定义参数：/users/:id 匹配 /users/1 以及 /users/po sva。
	meta: RouteMeta      // (可选) 在记录上附加自定义数据。
	name: string | symbol  // (可选) 路由记录独一无二的名称。
	alias: string | string[] // (可选) 路由的别名。允许定义类似记录副本的额外路由。这使得路由可以简写为像这种 /users/:id 和 /u/:id。 所有的 alias 和 path 值必须共享相同的参数。
	children: RouteRecordRaw,   //  数组 (可选), 当前记录的嵌套路由。
	beforeEnter: NavigationGuard | NavigationGuard[]   // (可选) 在进入特定于此记录的守卫之前。注意如果记录有重定向属性，则 beforeEnter 无效。
	redirect: RouteLocationRaw | (to: RouteLocationNormalized) => RouteLocationRaw  // (可选) 重定向
	(可选) 允许将参数作为 props 传递给由 router-view 渲染的组件。当传递给一个多视图记录时，它应该是一个与组件具有相同键的对象，或者是一个应用于每个组件的布尔值。
	props: boolean | Record<string, any> | (to: RouteLocationNormalized) => Record<string, any>
]
*/

const adminRoute: Array<RouteRecordRaw> = [
  {
    name: 'Insure',
    path: '/',
    meta: {
      title: 'route.insurance',
      hide: true, // 不需要在 菜单栏中 展示
      icon: '',
    },
    redirect: '/home',
  },
  {
    name: 'Home',
    path: '/home',
    meta: {
      title: 'route.operationHome',
      hide: true,
      icon: '',
    },
    component: () => import('@/pages/home/index.vue'),
  },
  {
    name: 'HomeLayout',
    path: '/',
    redirect: { name: 'Home' },
    component: () => import('@/layout/Workbench.vue'),
    children: [
      {
        name: 'CargoInsurance',
        path: '/cargo-insurance',
        meta: {
          title: 'route.cargoInsurance',
          icon: 'icon-base-draft-filled',
        },
        children: [
          {
            name: 'TraditionalInsurance',
            path: '/traditional-insurance',
            meta: {
              title: 'route.traditionalInsurance',
            },
            component: () =>
              import('@/pages/freight-insure/traditional-insure.vue'),
          },
          {
            name: 'CrossInsure',
            path: '/cross-insurance',
            meta: {
              title: 'route.crossInsurance',
              hide: isGlobal,
            },
            component: () => import('@/pages/freight-insure/cross-insure.vue'),
          },
          {
            name: 'RecycleBin',
            path: '/recycle-bin/:from',
            meta: {
              title: 'route.recycleBin',
              hide: true,
            },
            component: () => import('@/pages/freight-insure/recycle-bin.vue'),
          },
          {
            name: 'Iframe',
            path: '/iframe/:src',
            meta: {
              title: 'route.insure',
              hide: true,
              bread: [],
            },
            component: () => import('@/pages/iframe.vue'),
          },
          {
            name: 'AiScan',
            path: '/ai-scan',
            meta: {
              title: 'route.aiScan',
              hide: true,
              bread: [],
            },
            component: () => import('@/pages/ai-scan/index.vue'),
          },
          {
            name: 'HgjAll',
            path: '/hgj-all/:type/:mode',
            meta: {
              title: 'route.insure',
              hide: true,
            },
            component: () => import('@/pages/hgj-all/index.vue'),
          },
          {
            name: 'Hgj',
            path: '/hgj/:type/:mode',
            meta: {
              title: 'route.insureDetail',
              hide: true,
            },
            component: () => import('@/pages/hgj/index.vue'),
          },
          {
            name: 'CrossHgj',
            path: '/hgj-cross/:mode',
            meta: {
              title: 'route.crossInsureDetail',
              hide: true,
            },
            component: () => import('@/pages/hgj-cross/index.vue'),
          },
          {
            name: 'OnlineClaims',
            path: '/online-claims/:id',
            meta: {
              title: 'route.onlineClaims',
              hide: true,
            },
            component: () => import('@/pages/online-claims/index.vue'),
          },
        ],
      },
      {
        name: 'Liability',
        path: '/liability',
        meta: {
          title: 'route.liability',
          icon: 'icon-base-counter-filled',
          hide: isGlobal,
        },
        children: [
          {
            name: 'FreightLiability',
            path: '/freight-liability',
            meta: {
              title: 'route.freightLiability',
            },
            component: () => import('@/pages/liability/freight-liability.vue'),
          },
          {
            name: 'FreightLiabilityApply',
            path: '/freight-liability-apply',
            meta: {
              title: 'route.freightLiabilityApply',
              noTagBar: true,
              hide: true,
              bread: [],
            },
            component: () =>
              import('@/pages/liability/freight-liability-apply.vue'),
          },
        ],
      },
      {
        name: 'OnlineClaim',
        path: '/online-claim',
        meta: {
          title: 'route.claimRecord',
          icon: 'icon-base-insure-filled',
        },
        component: () => import('@/pages/claims-manage/claims-list.vue'),
      },
      {
        name: 'IframeClaim',
        path: '/iframe/:src',
        meta: {
          title: 'route.insure',
          hide: true,
          bread: [],
        },
        component: () => import('@/pages/iframe.vue'),
      },
      {
        name: 'BillList',
        path: '/bill-list',
        meta: {
          title: 'route.billList',
          icon: 'icon-base-bill-filled',
        },
        component: () => import('@/pages/be-settled/bill-list.vue'),
      },
      {
        name: 'PushSettings',
        path: '/push-settings',
        meta: {
          title: 'route.pushSettings',
          icon: 'icon-base-push-filled',
        },
        component: () => import('@/pages/push-setting/index.vue'),
      },
      {
        name: 'Invoice',
        path: '/invoice',
        meta: {
          title: 'route.invoiceInfo',
          icon: 'icon-base-invoice-filled',
        },
        component: () => import('@/pages/invoice/index.vue'),
      },
      {
        name: 'InvoiceManage',
        path: '/invoice-manage',
        meta: {
          title: 'route.invoiceManage',
          icon: 'icon-base-invoice-filled',
        },
        component: () => import('@/pages/invoice/manage.vue'),
      },
      {
        name: 'ConsumptionRecord',
        path: '/consumption-record',
        meta: {
          title: 'route.consumptionRecord',
          icon: 'icon-base-bill-filled',
        },
        component: () => import('@/pages/consumption-record/index.vue'),
      },
      {
        name: 'InsurerBillList',
        path: '/insurer-bill-list',
        meta: {
          title: 'route.insurerBillList',
          icon: 'icon-base-bill-filled',
        },
        component: () => import('@/pages/insurer-bill-list/index.vue'),
      },
      {
        name: 'UserAgreement',
        path: '/user-agreement',
        meta: {
          title: 'route.userAgreement',
          icon: 'icon-base-counter-filled',
        },
        component: () => import('@/pages/user-agreement/index.vue'),
      },
      {
        name: 'UserGuide',
        path: '/user-guide',
        meta: {
          title: 'route.userGuide',
          icon: 'icon-base-guide-filled',
        },
        component: () => import('@/pages/user-guide/index.vue'),
      },
    ],
  },
]

const routes: Array<RouteRecordRaw> = [...adminRoute]

// 注册
const router = createRouter({
  history: createWebHistory(
    normalizeBasePath(import.meta.env.VITE_PUBLIC_PATH),
  ), // 不 带 # 2023-06-21 正常使用
  // history: createWebHashHistory(),    // 带 #
  // hash: createWebHashHistory(),    // 没有 base，应用托管在域名 `https://example.com` 的根目录下。
  /* createWebHistory('/folder/')     // 给出的网址为 `https://example.com/folder/`
	   abstract: createMemoryHistory(process.env.BASE_URL), */
  routes,
})
// 前置守卫 - beforeResolve
router.beforeEach(async (to, from, next) => {
  const useTool = await useToolStore()
  useTool.setCurrentRoute(to.path) // 当前路由 - 高亮使用
  // console.log('前置守卫 to:', to, from)
  const aside = document.querySelector('.hgj-public-fixed-aside') as HTMLElement
  if (!to?.meta?.hide) {
    // 展示侧边栏的才会指向 name
    activeTabName.value = to.name as string
    activeMenuName.value = to.name as string
  }
  // console.log('aside', aside);
  if (
    (to.name === 'Iframe' || to.name === 'BillList') &&
    aside &&
    aside.style
  ) {
    aside.style.display = 'none'
  }
  if (
    (from.name === 'Iframe' || from.name === 'BillList') &&
    aside &&
    aside.style
  ) {
    aside.style.display = 'block'
  }
  next()
})

// 后置守卫
// router.afterEach((to, from, failure) => {
//     console.log('后置守卫 to:', to)
//     console.log('后置守卫 from:', from)
//     console.log('后置守卫 failure:',  failure)
// })

export default router
